// ResponsiveUnits.jsx → src/gestion-unites/
import React from "react";
import GestionUnites from "./GestionUnites";
import UnitsMobile from "../mobile/produits/UnitsMobile";
import useIsMobile from "../hooks/useIsMobile";

export default function ResponsiveUnits(props) {
  return useIsMobile() ? <UnitsMobile {...props} /> : <GestionUnites {...props} />;
}
